import React, { useEffect, useRef } from "react";

import "./stylesAllSports.css";

import Sortable from "sortablejs";
import ClipPath from "../../../../../assets/icons/ic_clip-path.svg";
import ToggleSwitch from "../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import { message } from "antd";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";

function AllSports({ liveSports, setLiveSports, reorderEntities }) {
  const tableBodyRef = useRef(null);
  const sortableRef = useRef(null);
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  useEffect(() => {
    if (!tableBodyRef.current) return;

    // Destroy any previous instance before creating a new one
    if (sortableRef.current) {
      sortableRef.current.destroy();
      sortableRef.current = null;
    }

    sortableRef.current = Sortable.create(tableBodyRef.current, {
      animation: 150,
      onEnd: (evt) => {
        setLiveSports((prevSports) => {
          if (!prevSports.length) return prevSports;

          const newOrder = [...prevSports];
          const [movedItem] = newOrder.splice(evt.oldIndex, 1);
          newOrder.splice(evt.newIndex, 0, movedItem);

          let orderCounter = 0;
          const updatedOrder = newOrder.map((item) => ({
            ...item,
            order: orderCounter++,
          }));

          const previousState = prevSports;

          (async () => {
            try {
              await reorderEntities(
                "SPORT",
                updatedOrder
                  .filter((sport) => sport.id !== "all-sports")
                  .map((sport) => sport.id),
                null
              );

              message.success("Order updated successfully!");
            } catch (err) {
              console.error("Error updating backend", err);
              setLiveSports(previousState);
              message.error("Error updating order. Please try again.");
            }
          })();

          return updatedOrder;
        });
      },
    });
    return () => {
      if (sortableRef.current) {
        sortableRef.current.destroy();
        sortableRef.current = null;
      }
    };
  }, [reorderEntities, setLiveSports]);

  const updateSportStatus = (payload) => {
    const entityId = `SPORT#${payload.event_code}`;
    const isActive = payload.is_active;

    const previousState = [...liveSports.map((s) => ({ ...s }))];
    const updatedState = liveSports.map((s) =>
      s.id === payload.event_code ? { ...s, status: isActive } : s
    );
    setLiveSports(updatedState);

    (async () => {
      try {
        const res = await PrivateAdminPanelInstance.post(
          API_ROUTES.SET_ENTITY_ACTIVE_STATUS,
          {
            entity_type: "LIVE",
            entity_id: entityId,
            is_active: isActive,
          }
        );
        if (res.status !== 200 || res.data?.success === false) {
          throw new Error(`Status ${res.status}`);
        }
        message.success(
          isActive
            ? "Sport activated successfully"
            : "Sport deactivated successfully"
        );
      } catch (err) {
        console.error("Error updating sport status", err);
        message.error("Error updating sport status. Reverting change.");
        setLiveSports(previousState);
      }
    })();
  };

  return (
    <div>
      <table className="fm-live-sports-table">
        <thead>
          <tr>
            <th># Order</th>
            <th>Sport Name</th>
            <th>Live Activity</th>
          </tr>
        </thead>
        <tbody ref={tableBodyRef}>
          {liveSports.map((sport) => (
            <tr key={sport.id}>
              <td className="drag-handle">
                <div className="fm-live-sports-table-order-container">
                  <img src={ClipPath} alt="ClipPath" />
                  {sport.order}
                </div>
              </td>
              <td>{sport.name}</td>
              {sport.id === "all-sports" ? (
                <td></td>
              ) : (
                <td>
                  <ToggleSwitch
                    eventCode={sport.id}
                    updateEventCode={updateSportStatus}
                    status={sport.status}
                    data={sport}
                    onlyUpdate={false}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AllSports;

